import React from "react";
import { Box, Button, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import Modal from "../Modal";
import { ReportProblemOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import ButtonGroup from "../Buttons/ButtonGroup";

const useStyles = makeStyles(() => ({
  icon: {
    width: "100%",
    height: "100%"
  }
}));

const WarningModal = ({
  open,
  onClose,
  onSubmit,
  warningMessage,
  submitButtonText,
  hideButtons,
  showCloseIcon,
  hideWarningIcon,
  title
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Modal
      scrollable
      maxWidth="sm"
      fullWidth
      dialogContent={
        <Box display="flex" mt={hideWarningIcon ? 0 : 2} mb={1}>
          {!hideWarningIcon && (
            <Box mr={1.5} minWidth={60} maxWidth={120} height={60}>
              <ReportProblemOutlined color="primary" className={classes.icon} />
            </Box>
          )}
          <Box pr={1.5}>
            {typeof warningMessage === "string" ? (
              <Typography>{warningMessage}</Typography>
            ) : (
              warningMessage
            )}
          </Box>
        </Box>
      }
      dialogActions={
        !hideButtons && (
          <ButtonGroup>
            <Button color="primary" onClick={() => onClose()}>
              {t("cancelBtn")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => onSubmit()}
            >
              {submitButtonText ? submitButtonText : t("okBtn")}
            </Button>
          </ButtonGroup>
        )
      }
      dialogTitle={title}
      open={open}
      onClose={() => onClose()}
      showCloseIconWithoutTitle={showCloseIcon}
    />
  );
};

export default WarningModal;

WarningModal.propTypes = {
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the modal is closed
   */
  onClose: PropTypes.func,
  /**
   * Called when the OK button is pressed
   */
  onSubmit: PropTypes.func,
  submitButtonText: PropTypes.string,
  hideButtons: PropTypes.bool
};
